type WebBootstrap = (lifetime: DisposableStack) => Promise<void>;
type BootstrapErrorReporter = (error: unknown) => void;

const reportBootstrapError: BootstrapErrorReporter = (error) => {
    // The structured logger is initialized during container startup, so the
    // browser console is the only diagnostic guaranteed to exist here.
    // eslint-disable-next-line no-console -- bootstrap may fail before logging is available
    console.error('Web application bootstrap failed', error);
};

export const runWebBootstrap = async (
    bootstrap: WebBootstrap,
    reportError: BootstrapErrorReporter = reportBootstrapError,
): Promise<void> => {
    const lifetime = new DisposableStack();
    try {
        await bootstrap(lifetime);
    } catch (error) {
        lifetime[Symbol.dispose]();
        reportError(error);
    }
};
